module.exports = __webpack_public_path__ + "static/media/intro4.26e3d948.jpg";